import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { _AdquisitionBudgetDocuments, _AdquisitionItemByPaa } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicPage } from "../../theme/Component/BasicPage";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { Modal } from "../../theme/Component/Modal";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";



interface Props {
    idProject: any;
}

export const BudgetDocuments = ({ idProject }: Props) => {

    const bydoc = useDataBean(_AdquisitionBudgetDocuments);
    const [lista, setLista] = useState<any>([]);
    const paginador = usePaginator();
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [modalverdoc, setModalverdoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    useEffect(() => {
        getListavdos();
    }, [paginador.page, idProject])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const head = [
        { title: 'ID', property: 'IDDocument', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Fecha', property: 'DocumentDate', visible: true },
        { title: 'Consecutivo', property: 'DocumentConsecutive', visible: true },
        { title: 'Identificación', property: 'AccountID', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true, mask: MASK_MONEY },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
    ]

    const getListavdos = () => {

        bydoc.instance.getBudgetDocuments(idProject).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }
    const verDocumentos = () => {

        if (bydoc.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(bydoc.bean.IDDocument, null, bydoc.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-file-history-line', visible: true, evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <div className="row">
            <BasicPage titulo="Documentos Presupuestales">
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} listButtons={listaBotones()} rowSet={bydoc.setBean}></BasicTable>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={bydoc.bean.IDDocument}
                                        Since={bydoc.bean.DocumentDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </BasicPage>


        </div>
    )
}